import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=476afe32&scoped=true"
import script from "./dealer.vue?vue&type=script&lang=js"
export * from "./dealer.vue?vue&type=script&lang=js"
import style0 from "./dealer.vue?vue&type=style&index=0&id=476afe32&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476afe32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476afe32')) {
      api.createRecord('476afe32', component.options)
    } else {
      api.reload('476afe32', component.options)
    }
    module.hot.accept("./dealer.vue?vue&type=template&id=476afe32&scoped=true", function () {
      api.rerender('476afe32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/dealer_address/components/dealer.vue"
export default component.exports